// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"27":"vendor-ckeditor","378":"admin-app","743":"vendor-react-player"}[chunkId] || chunkId) + ".bundle.js";
};